import React, { FC } from 'react';

import useChargesKMLN from '../services/useGetChargesKM';
import ChargesJKScene from './charges-jk-scene';

interface Props {
  showHeaderAndContainer?: boolean;
}

const ChargesJK: FC<Props> = ({ showHeaderAndContainer = true }) => {
  const {
    dataCharges,
    handleDelete,
    handleEditModal,
    openAddModal,
    state,
    handleAddModal,
    reloadAccounting,
  } = useChargesKMLN(['J', 'K']);

  return (
    <ChargesJKScene
      accountingData={dataCharges || []}
      handleDelete={handleDelete}
      handleEditModal={handleEditModal}
      openAddModal={openAddModal}
      handleaddModal={handleAddModal}
      reloadAccounting={reloadAccounting}
      state={state as any}
      showHeaderAndContainer={showHeaderAndContainer}
    />
  );
};

export default ChargesJK;
